import { render } from "./AboutMeView.vue?vue&type=template&id=2e4f1920&scoped=true"
const script = {}

import "./AboutMeView.vue?vue&type=style&index=0&id=2e4f1920&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4f1920"]])

export default __exports__